import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";

import { ICubicleFilter } from "../models/filters/cubicleFilter";
import { ICubicleForm } from "../models/forms/cubicleForm";
import { ICubiclePDTO } from "../models/dtos/cubiclePDTO";

// Service for Cubicle operations
export default class CubicleService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/Cubicle";

    protected static override  getUrlFilter<F extends ICubicleFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.buildingId != undefined)
                url += `&BuildingId=${filter.buildingId}`;

            if(filter.typeLocationId != undefined)
                url += `&TypeLocationId=${filter.typeLocationId}`;
        }
        
        return url;
    }

    public static override toDTO(obj:ICubicleForm):ICubiclePDTO {
        const dto = super.toDTO(obj) as ICubiclePDTO;
        return dto;
    }
}